import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const InvoiceQR = ({ upiId, amount, onQrGenerated }) => {
  const [qrDataUrl, setQrDataUrl] = useState('');

  useEffect(() => {
    if (!upiId) return;
    const upiUrl = `upi://pay?pa=${upiId}&am=${amount || ''}&cu=INR`;
    QRCode.toDataURL(upiUrl, { width: 150 }, (err, url) => {
      if (!err && url) {
        setQrDataUrl(url);
        if (onQrGenerated) onQrGenerated(url); // Pass to parent
      }
    });
  }, [upiId, amount, onQrGenerated]);

  return (
    <div>
      <b>Scan to Pay via UPI</b>
      {qrDataUrl && <img src={qrDataUrl} alt="UPI QR" style={{ width: 120, height: 120 }} />}
      {upiId}
    </div>
  );
};

export default InvoiceQR;
